import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-[5px] z-50 right-[2px] text-white" }

import { ref, computed, watch, onMounted } from 'vue';
import { IonContent, IonPopover, IonIcon, IonButton, IonList, IonItem, IonLabel,isPlatform } from '@ionic/vue';
import { createOutline, ellipsisVertical, settingsOutline, volumeHighOutline, volumeMuteOutline } from 'ionicons/icons';
import { useRoute, useRouter } from 'vue-router';
import { stopAllSounds } from '@/utils';
import { Preferences } from '@capacitor/preferences';


export default /*@__PURE__*/_defineComponent({
  __name: 'player-menu',
  setup(__props) {

const route = useRoute();
const router  = useRouter();

const open = ref(false);
const event = ref<Event|null>(null);
const soundActivated = ref(true);

const toggleOpen = (ev: Event) => {
    event.value = ev;
    open.value = !open.value;
};

const toggleSound = () => {
    soundActivated.value = !soundActivated.value;
};

const goToPageSettings = () => {
    router.push({ name: 'settings' });
    open.value = false;
};

const goToPageEditInfos = () => {
    router.push({ name: 'infos' });
    open.value = false;
}

const visible = computed(() => route.meta.showPlayerMenu);

watch(() => soundActivated.value, async (value) => {
    if(! value) {
        stopAllSounds();
    }
    await Preferences.set({ key: 'SOUND_STATE', value: (value ? '1' : '0') });
});

onMounted(() => {
    requestAnimationFrame(async () => {
        const { value } = await Preferences.get({ key: 'SOUND_STATE' });
        soundActivated.value = Boolean(Number(value));
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_unref(IonButton), {
        size: _unref(isPlatform)('ios') ?  'small' : 'default',
        onClick: _withModifiers(toggleSound, ["prevent"]),
        slot: "icon-only",
        class: "popover-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            icon: soundActivated.value ? _unref(volumeHighOutline) : _unref(volumeMuteOutline)
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["size"]),
      _createVNode(_unref(IonButton), {
        size: _unref(isPlatform)('ios') ?  'small' : 'default',
        onClick: toggleOpen,
        id: "click-trigger",
        slot: "icon-only",
        class: "popover-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), { icon: _unref(ellipsisVertical) }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["size"])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(IonPopover), {
      trigger: "click-trigger",
      "is-open": open.value,
      event: event.value,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), { color: "light" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonList), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), {
                  shape: "round",
                  onClick: goToPageEditInfos,
                  button: true,
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(createOutline),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Modifier mon profil", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), {
                  shape: "round",
                  onClick: goToPageSettings,
                  button: true,
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(settingsOutline),
                      slot: "start"
                    }, null, 8, ["icon"]),
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Paramètres", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "event"])
  ]))
}
}

})